import React from 'react';
import Card from '@material-ui/core/Card';
import CommentCardHeader from '../../../atoms/comments/card-header';
import CardContent from '@material-ui/core/CardContent';
import styles from './styles.scss';
import AvatarCustom from '../../../atoms/avatar/AvatarCustom';
import { inIframe } from '../../../../utils/iframe-utils';
import Utils from '../../../../utils/comments-utils';
import { CardProps } from '../../../../utils/comments/types';
import ReplyCard from './ReplyCard';

/* CommentCard displays a single comment card */
const CommentCard = function CommentCard(
    { comment, avatarSrc, pageUrl, targetName }: CardProps
) {
    return (
        <div className={styles.commentcard}>
            <Card className={`${styles.root} `}>
                <CommentCardHeader
                    avatar={(
                        <div>
                            <AvatarCustom author={comment.Author} />
                        </div>
                    )}
                    // card action to display donation amount, style of action seems fit our design
                    action={(
                        <div>
                            <div className={styles.row}>
                                <div className={styles.amount}>
                                    {`$${comment.Amount}`}
                                </div>
                                <div className={`${styles.row} ${styles['created-text']}`}>{Utils.CalculateTimeDiff(comment.Created)}</div>
                            </div>
                        </div>
                    )}
                    subheader={(
                        <div>
                            <div className={`${styles['no-bottom-margin']} columns`}>
                                <div className={`${styles.donor} ${styles['long-comment']} ${styles['pop-up-comment']}`}>
                                    <p className={styles['truncate-single-line']}>
                                        {comment.Author ? comment.Author : 'Anonymous'}
                                    </p>
                                </div>
                                <div className={`${styles['donated-to']} column`}>
                                    {' donated to'}
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.column}>
                                    <p className={styles['truncate-single-line']}>
                                        <a href={pageUrl} target={inIframe() ? '_parent' : '_self'} className={styles.organization} onClick={(e) => e.stopPropagation()}>
                                            {targetName}
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                />
                <CardContent className={`${styles.comment} `}>
                    <div>
                        <p>{comment.MessageText}</p>
                    </div>
                </CardContent>
                <ReplyCard avatarsrc={avatarSrc} reply={comment.Reply} />
            </Card>
        </div>
    );
};

export default CommentCard;
